<template>
  <div class="jflow-transpond-box">
    <Row>
      <Col span="3">
      <div style="line-height:26px;">接收人：</div>
      </Col>
      <Col span="12">
      <Select filterable remote clearable label-in-value placeholder="请输入姓名搜索" :remote-method="getHrusersList" :loading="selectLoading" @on-change="selectChange">
        <Option v-for="(option, index) in hrusersList" :value="option.value" :key="index">{{option.label}}</Option>
      </Select>
      </Col>
    </Row>
    <Row style="margin-top:10px">
      <Col span="24">
      <div>
        <span style="">转发批注：</span>
        <Input class="ref_input" v-model="inputValue" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入转发批注" />
      </div>
      </Col>
    </Row>
    <div class="pop-btn">
      <Button class="cancel-btn" @click="cancel">
        <span>{{ chineseName.CANCEL }}</span>
      </Button>
      <Button type="error" class="sav-btn" @click="save">
        <span>{{ chineseName.CONFIRM }}</span>
      </Button>
    </div>
  </div>
</template>

<script>
import ChineseDictionary from "@/assets/js/ChineseDictionary";
export default {
  name: "JflowTranspond",
  inject: ["moduleComponentName", "instanceRouteQuery", "instanceRoute"],
  data() {
    return {
      inputValue: "",
      hrusersList: [], //接收人
      selectLoading: false,
      selectedHruser: null,
      okBtnflag: true, // 转发确认防止重复点击 [true:可以点击，false：不可点击]
    };
  },
  created() {
    this.chineseName = ChineseDictionary;
    // const { tableName, tableId, itemId } = this.$router.currentRoute.params;
    // console.log('userInfo :>> ', this.$store.state.global.userInfo);
    // console.log("jflow:",this.$store.state);
    // this.$network.post('/p/cs/checkButtonIsHide', {
    //   objid: itemId
    // }).then(res => {
    //     console.log('res :>> ', res);
    // });
  },
  activated() { },
  destroyed() { },
  methods: {
    getHrusersList(query) {
      //   console.log('userInfo :>> ', JSON.parse(JSON.stringify(this.$store.state.global.userInfo)));
      // http://cmsqas.lining.com/p/cs/queryHrusersList
      if (query) {
        this.selectLoading = true
        this.$network.post("/p/cs/queryHrusersList", {
          page: 1,
          pageSize: 20,
          ename: query
        }).then((res) => {
          // console.log('res :>> ', res);
          if (res.data.resultCode == 0) {
            // console.log('accounts :>> ', res.data.data.accounts);
            const list = res.data.data.accounts.map(item => {
              return {
                value: item.accountId,
                label: item.ename + `(${item.accountName})`
              };
            });
            this.hrusersList = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
            // console.log('this.hrusersList :>> ', this.hrusersList);
          }
        }).finally(_ => {
          this.selectLoading = false
        });
      } else {
        this.hrusersList = []
      }
    },
    selectChange(val) {
      //   console.log('selectChange.val :>> ', val);
      this.selectedHruser = val
    },
    save() {
      // console.log('selectedHruser :>> ', this.selectedHruser);
      if (!this.selectedHruser) {
        const data = {
          mask: true,
          title: "警告",
          content: "请选择接收人",
        };
        this.$Modal.fcWarning(data);
        return;
      }
      let idx = this.selectedHruser.label.indexOf("(")
      this.selectedHruser.label = this.selectedHruser.label.substr(0, idx)
      if (!this.inputValue.trim()) {
        const data = {
          mask: true,
          title: "警告",
          content: "请输入转发批注",
        };
        this.$Modal.fcWarning(data);
        return;
      }
      const { tableName, tableId, itemId } = this.$router.currentRoute.params;
      const params = {
        table: tableName,
        tableId: tableId,
        objid: itemId,
        approver: this.$store.state.global.userInfo.id,
        approverName: this.$store.state.global.userInfo.ename,
        recipientId: this.selectedHruser.value,
        recipientName: this.selectedHruser.label,
        approverType: 1,
        transpondComment: this.inputValue,
      };
      // 重复点击拦截
      if(this.okBtnflag){
        this.okBtnflag = false;
      } else {
        return;
      }
      this.$network.post("/p/cs/jflowTranspond", params).then((res) => {
        if (res.data.data.code == 0) {
          this.$Modal.fcSuccess({
            title: "成功",
            content: "转发成功",
          });
          this.$emit("closeActionDialog", true); // 关闭弹框
          this.okBtnflag = true;
        } else {
          this.$Modal.fcError({
            title: "失败",
            content: res.data.data.message,
          });
          this.$emit("closeActionDialog", true); // 关闭弹框
          this.okBtnflag = true;
        }
      });
    }, // 确定
    cancel() {
      this.$emit("closeActionDialog", false); // 关闭弹框
    }, // 取消
  },
};
</script>

<style lang="less">
.jflow-transpond-box {
  .ref_input {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .pop-btn {
    display: flex;
    flex-direction: row-reverse;

    .cancel-btn {
      margin-left: 10px;
    }
  }
}
</style>
